<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4354_5124)">
      <path d="M12.1912 23.2838C18.1086 23.2838 22.9055 18.247 22.9055 12.0338C22.9055 5.82061 18.1086 0.783813 12.1912 0.783813C6.27388 0.783813 1.47693 5.82061 1.47693 12.0338C1.47693 18.247 6.27388 23.2838 12.1912 23.2838Z" fill="#FFCF26"/>
      <g filter="url(#filter0_i_4354_5124)">
        <path d="M12.191 21.4841C17.1616 21.4841 21.191 17.2532 21.191 12.0341C21.191 6.81502 17.1616 2.58411 12.191 2.58411C7.22048 2.58411 3.19104 6.81502 3.19104 12.0341C3.19104 17.2532 7.22048 21.4841 12.191 21.4841Z" fill="#FFCF26"/>
      </g>
      <g filter="url(#filter1_d_4354_5124)">
        <path d="M17.5483 6.03381V7.25871C15.7405 7.40804 14.1863 8.41129 13.4609 9.73418C13.6814 7.66002 15.4275 6.03381 17.5483 6.03381Z" fill="white"/>
        <path d="M17.5482 7.25891V13.4488C17.5482 16.4281 15.1519 18.8453 12.1934 18.8453C9.95787 18.8453 8.04208 17.4664 7.24182 15.5065C7.83264 16.4632 8.88644 17.1024 10.0879 17.1024C12.0942 17.1024 13.3794 15.6513 13.4367 13.8384H13.439V10.1754C13.4392 10.0257 13.4473 9.87612 13.4632 9.72738C14.3273 8.29716 15.6986 7.30091 17.5482 7.25891Z" fill="white"/>
        <path d="M11.9618 14.9046C11.7919 15.2312 11.4834 15.4693 10.9454 15.6629C9.01419 16.1646 7.16234 14.6527 6.87354 12.8772C8.02213 15.229 10.2466 14.9794 10.9476 14.3867C10.9917 14.9396 11.4789 15.0469 11.9618 14.9046Z" fill="white"/>
        <path d="M10.9455 14.3095C10.9455 14.3375 10.9477 14.3655 10.9477 14.3911C10.2445 14.9838 8.09059 15.3314 6.87366 12.8769C6.84724 12.7206 6.83396 12.5622 6.83398 12.4033V6.03381C9.1047 6.03381 10.9433 7.88867 10.9433 10.1751V14.3095H10.9455Z" fill="white"/>
      </g>
    </g>
    <defs>
      <filter id="filter0_i_4354_5124" x="3.19104" y="2.58411" width="18" height="22.9" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4354_5124"/>
      </filter>
      <filter id="filter1_d_4354_5124" x="1.83398" y="5.03381" width="20.7142" height="22.8115" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4354_5124"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4354_5124" result="shape"/>
      </filter>
      <clipPath id="clip0_4354_5124">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
